module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('v-flex', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.categoriasVisiveis > 0),
      expression: "categoriasVisiveis > 0"
    }],
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": ""
    },
    on: {
      "click": _vm.verCategorias
    }
  }, [_c('div', {
    staticClass: "box"
  }, [_c('v-checkbox', {
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "label": _vm.classe.Nome
    },
    model: {
      value: (_vm.classeSelecionada),
      callback: function($$v) {
        _vm.classeSelecionada = $$v
      },
      expression: "classeSelecionada"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "classNumber",
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v(_vm._s(_vm.categoriasVisiveis))])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-77ba2a7f","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tabelaClasses/Classe.vue
// module id = 763
// module chunks = 5